
import { LocalNavComponent } from "../local-nav.component"
import { TbwNewsletterFormComponent } from '../newsletter/tbw-newsletter-form.component'
import { TbwMicaChartsComponent } from '../mica/tbw-mica-charts.component'

export const registerComponents = () => {
  customElements.define('tbw-local-nav', LocalNavComponent)
  customElements.define('tbw-newsletter-form', TbwNewsletterFormComponent)
  customElements.define('tbw-mica-charts', TbwMicaChartsComponent)
}